import React from 'react'
import { CircularProgress } from '@mui/material'
import { LoadingContainer } from './styles'
import type { LoadingSpinnerProps } from './types'

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ disableFullScreen = false }) => (
  <LoadingContainer disableFullScreen={disableFullScreen} aria-label="Loading animation">
    <CircularProgress />
  </LoadingContainer>
)

export default LoadingSpinner
